import { atom } from 'jotai';
import { create } from 'zustand';
import update from 'immutability-helper';
import { get } from "lodash";

export const defaultSaveTemplate = () => ({
  meta: {},
  config: {},
  initialSavedData: {},
});

export const useSaveStore = create((set) => ({
  name: 'save-store',
  saves: {},
}));

//NOTE: if section level set is required, refer to export and reuse improved update flow
export const updateSaveData = ({ pageKey, state }) =>
  useSaveStore.setState((currentState) => {
    return update(currentState, {
      saves: {
        [pageKey]: {
          $set: state,
        },
      },
    });
  });

export function useUpdateSave({ pageKey }) {
  const updateData = (state) => {
    updateSaveData({ pageKey, state });
  };
  return {
    updateData,
  };
}

// subscribes and re-renders
export function useGetSave({ pageKey }) {
  const saveData = useSaveStore((state) => state.saves[pageKey]);
  return {
    saveData,
  };
}

// off the hook, literally
export function getSaveData({ pageKey }) {
  const store = useSaveStore.getState();
  return get(store, ['saves', pageKey], defaultSaveTemplate());
}

export const savedDashboardCreatorIdAtom = atom(null);
